module.exports = __webpack_public_path__ + "static/SSL25364-e7f5139e54ec6998316bdef8a04c5826.jpg";